<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeBungeSubEmpresa',
    componentOptions: {
        title: 'RastreabilidadeBungeSubEmpresa',
        actions: [
            [
                {
                    name: 'Rastreabilidade',
                    iconClass: 'lyra-icon bunge-rastreabilidade',
                    showView: false,
                    action: 'abrir',
                    route: 'RastreabilidadeSubEmpresa'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'RastreabilidadeSubEmpresa') {
                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
